<div class="row list-item custom lrg">
  <div
    class="col data padding all"
    [ngClass]="{
      last: last
    }"
    *ngFor="let column of libraryItemData.columns; let last = last"
  >
    <div class="flex-parent long-and-truncated">
      <!-- <div class="caption long-and-truncated">{{ column.label }}:</div> -->
      <div class="custom section-data padding sm left">
        <span class="caption">{{ column.label }}: </span>{{ column.data }}
      </div>
    </div>
  </div>
</div>
